import {
    COLLAPSE_ALL_FOOTBALL_MARKETS,
    EXPAND_ALL_FOOTBALL_MARKETS,
    EXPAND_COLLAPSE_FOOTBALL_MARKET
} from '../constants/actionTypes';

export function expandCollapseMarket(marketIndex) {

    return {type: EXPAND_COLLAPSE_FOOTBALL_MARKET, marketIndex};
}

export function expandAllMarkets() {

    return {type: EXPAND_ALL_FOOTBALL_MARKETS};
}

export function collapseAllMarkets() {

    return {type: COLLAPSE_ALL_FOOTBALL_MARKETS};
}



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/actions/marketsActions.js